export default {
	title: "Mon profil",
	tabs: {
		personal: "Informations personnelles",
		religious: "Religieux",
		security: "Sécurité",
	},
	fields: {
		displayName: "Nom d'affichage",
		email: "E-mail",
		phone: "Téléphone",
		whatsappOptIn: "Recevoir les alertes de l'ORI par WhatsApp",
		whatsappOptInHint: "Avis de gestion du temple (paiements reçus, dépenses, clôture) envoyés depuis le numéro officiel de l'ORI au téléphone ci-dessus",
		religiousName: "Nom religieux",
		title: "Titre",
		ritualFunction: "Fonction rituelle",
		role: "Rôle au temple",
		currentPassword: "Mot de passe actuel",
		newPassword: "Nouveau mot de passe",
		confirmPassword: "Confirmer le nouveau mot de passe",
	},
	photo: {
		change: "Changer la photo",
		remove: "Supprimer la photo",
	},
	messages: {
		saved: "Profil mis à jour avec succès",
		photoUploaded: "Photo mise à jour avec succès",
		photoRemoved: "Photo supprimée avec succès",
		errorSaving: "Erreur lors de l'enregistrement du profil",
		errorPhoto: "Erreur lors de la mise à jour de la photo",
		changePassword: "Changer le mot de passe",
		passwordChanged: "Mot de passe changé avec succès",
		passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
		wrongCurrentPassword: "Le mot de passe actuel est incorrect",
	},
	stats: {
		temple: "Temple",
	},
};
